// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"19":"6e83d8fd","312":"c80c4102","363":"1e82084c","526":"962dd845","897":"175ede99"}[chunkId] + ".chunk.css";
};